import type { AccrualsRepositoryT } from "../../domain/ports/accruals.repository";
import type { AccrualRowWithIndexT } from "../../domain/types/accrual.types";
import type { AccrualLoadResultT } from "../../domain/entities/accrual.entity";

type LoadInitialDataParamsT = {
  accrualsRepository: AccrualsRepositoryT;
  rows: AccrualRowWithIndexT[];
  colaboraInstanceId: string;
};

export const loadInitialData = async ({
  accrualsRepository,
  rows,
  colaboraInstanceId,
}: LoadInitialDataParamsT): Promise<AccrualLoadResultT> =>
  accrualsRepository.load(rows, colaboraInstanceId);
